/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */
import React from 'react';
import { getSessionDatas, getContentByLocal, trackEvent, setTitle } from '../../../utils';
import { findQuestionById, documentCheckListQuestionShouldDisplay } from '../../../utils/AOFormUtils';
import history from '../../../utils/history';
import paths from '../../../config/path';
import BasePage from '../../../shared/BasePage';
import { Button } from 'react-bootstrap';
import { apiMap, settings } from '../../../config/constants';
import UploadCom from './child/UploadCom';
import FileSamplesView from './child/FileSamplesView';
import FileView from './child/FileView';
import FileDesc from './child/FileDesc';
import AOForm from '../../../shared/AOForm';
import FormTitle from '../../../shared/AOForm/components/FormTitle';
import StepIndicator from '../../../shared/StepIndicator';

// import sPth1 from '../../../theme/images/img_banner_help_web@3x.png';
// import sPth2 from '../../../theme/images/img_document_banner_HK_web@3x.png';
//import OrgChart from '../../../theme/images/OrgChart.png';
import OrgChartOff from '../../../theme/images/orgchart_off.jpg';
import ComReportStandIndSelfCertFile from '../../../theme/images/RBWM-CRS-SC-Form.pdf';
import DeclaStaAccUSTaxPrinFile from '../../../theme/images/Declaration-of-Status according-to-US-Tax-Principles.png';
/* eslint-disable array-callback-return */
/* eslint-disable no-mixed-operators */
/* eslint-disable radix */
class FileUploadInfo extends BasePage {
  constructor(props) {
    super(props);
    this.state = {
      pageData: null,
      copyPageData: null,
      errorMsg: null,
      isShowModal: false,
      isFileView: false,
      imgModalArray: [],
      isShowDialog: false,
      isShowOtherDialog: false,
      deleteQuestionId: "",
      isFinishCommit: false,
      requestJson : {
        "documentData": {
          "convertToPdf":false,
          "rqstUser": "rbbUser",
          "groupMbrCde": "HBCN",
          "ctryCde": "CN",
          "lineOfBus": "RBWM",
          "rptyId": "FileNetP8CE",
          "objStoreName": "RBWM",
          "docClassName": "Corporate_Document",
          "appId": "CNAI",
          //"callbackUrl": settings.hostnameCallBack,
          "documentProperties": [
            {
              "name": "DocumentType",
              "type": "String",
              "value": "Onboarding"
            },
            {
              "name": "Source",
              "type": "String",
              "value": "ICCM"
            },
            {
              "name": "ApplicationCode",
              "type": "String",
              "value": "RBBO"
            },
            {
              "name": "IDType",
              "type": "String",
              "value": ""
            },
            {
              "name": "IDValue",
              "type": "String",
              "value": ""
            },
            {
              "name": "NumberType",
              "type": "String",
              "value": "Application ID"
            },
            {
              "name": "NumberValue",
              "type": "String",
              "value": ""
            },
            {
              "name": "OtherReference",
              "type": "String",
              "value": ""
            },
            {
              "name": "OtherReference2",
              "type": "String",
              "value": ""
            }]
        }
      }
    };
    this.pageKey = this.props.match.params.id;
    this.closeModal = this.closeModal.bind(this);
    this.handleFileView = this.handleFileView.bind(this);
    this.closeFileView = this.closeFileView.bind(this);
    this.closeDeleteDialog = this.closeDeleteDialog.bind(this);
    this.openDeleteDialog = this.openDeleteDialog.bind(this);
    this.closeOtherDeleteDialog = this.closeOtherDeleteDialog.bind(this);
    this.handleUploadFile = this.handleUploadFile.bind(this);
    this.handleFinish = this.handleFinish.bind(this);
    this.handlePrev = this.handlePrev.bind(this);
    this.handleDeleteLastFileStorage = this.handleDeleteLastFileStorage.bind(this);
    this.addOtherFile = this.addOtherFile.bind(this);
    this.deleteOtherFile = this.deleteOtherFile.bind(this);
    this.setCurrentPageData = this.setCurrentPageData.bind(this);
    this.soleTraderIndicator = 'MenuBusinessSoleTraderDocFile';
  }

  componentDidMount(){
    // setRequestJson
    this.setRequestJson(this.props);
    // add status
    this.getAppAndStatus(this.props);
    // init pageData
    this.setCurrentPageData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    const { pageData } = this.state;
    // add questions questionStatus
    this.getAppAndStatus(nextProps);
    // init pageData
    if (pageData && Object.keys(pageData).indexOf(this.pageKey) === -1) {
      this.setCurrentPageData(nextProps);
    }
  }

  getAppAndStatus = ({applicationInfo, businessInfo, match}) => {
    const { questionStatus, companyInfo } = businessInfo;
    const dataS004 = findQuestionById(applicationInfo, 'S004');
    if (companyInfo) {
      applicationInfo.companyInfo = businessInfo.companyInfo;
    }
    questionStatus && Object.keys(questionStatus).map(indicate => {
      dataS004.questions.map(item => {
        if (item.questionIndicator === indicate) {
          item.questionStatus = questionStatus[indicate];
        }
        if (item.questionIndicator === match.params.id) {
          this.pageKey = item.questionId;
        }
      })
    });
  };

  setRequestJson = (props) => {
    const {applicationInfo, businessInfo} = props;
    if(applicationInfo && businessInfo) {
      const { companyInfo, idInfo } = businessInfo;
      const { requestJson } = this.state;
      const idType = idInfo.idType || '';
      const idNo = idInfo.idNo || '';
      const comDocNum = companyInfo.comDocNum || ' ';
      const { documentData: { documentProperties } } = requestJson;
      // IDType: 1:"ID" / 2:"Passport" / 3:"Others"
      let idTypeV;
      switch(parseInt(idType)) {
        case 1: idTypeV = "ID"; break;
        case 2: idTypeV = "Passport"; break;
        case 3: idTypeV = "Others"; break;
        default: idTypeV = "ID";
      }
      documentProperties[3].value = idTypeV;
      // IDValue
      documentProperties[4].value = idNo;
      // NumberValue
      documentProperties[6].value = getSessionDatas().applicationId;
      // get mobile
      documentProperties[8].value = comDocNum;
    }
  };

  setCurrentPageData (props) {
    const { applicationInfo, businessInfo, flieUploadInfo, match } = props;
    if(applicationInfo) {
      const sectionInfoS004 = JSON.parse(JSON.stringify(findQuestionById(applicationInfo, 'S004')));
      const { uploadFiles,  answerDetails } = businessInfo;
      let isMatchUrl = true;
      let soleTraderAnswer = '';
      sectionInfoS004 && sectionInfoS004.questions.map((questionItem, index) => {
        const { questionIndicator } = questionItem;
        if(questionIndicator === match.params.id) {
          // questions status
          isMatchUrl = false;
          if(businessInfo.questionStatus) {
            Object.keys(businessInfo.questionStatus).map((key, index) => {
              if(key === questionIndicator) {
                questionItem.questionStatus = businessInfo.questionStatus[key]
              }
            })
          }
          questionItem.subQuestions.map((subQuestionsItem, index) => {
            const subIndicator = subQuestionsItem.questionIndicator;
            if (subQuestionsItem.answerType === 6) {
              subQuestionsItem.userAnswer = {
                "name": null,
                "documentUploadId": null,
                "iccmFileNetId": null,
                "fileNetId": null,
                "status": null,
                "type": null,
                "indicator": subIndicator,
                "docUploadRespDateTime": null,
                "iccmRespDateTime": null
              };
            } else if (subQuestionsItem.answerType === 5) {
              subQuestionsItem.userAnswer = {
                chosenAnswerId: ''
              };
            }
            // userAnswer
            if(uploadFiles && Object.keys(uploadFiles).length > 0) {
              Object.keys(uploadFiles).map((indicator, index) => {
                // 根据other答案: 拼出other界面结构   例如：questionIndicator: MenuOtherDocFile002   ---> questionId: "Q004-020-002"
                const bussiIndicator = uploadFiles[indicator];
                const indicatorArr = bussiIndicator && bussiIndicator !=null && indicator.split(questionIndicator);

                if(subQuestionsItem.answerType === 6 && bussiIndicator !=null && indicatorArr &&
                  indicatorArr[1] && indicatorArr[1].length > 0 && indicator.indexOf(questionIndicator) === 0 && parseInt(indicatorArr[1]) > 0) {
                  const subQuestionTemplate = JSON.parse(JSON.stringify(flieUploadInfo.subQuestionTemplate));
                  subQuestionTemplate.userAnswer= bussiIndicator;
                  subQuestionTemplate.questionStatus = businessInfo.questionStatus[indicator];
                  subQuestionTemplate.questionId = `${this.pageKey}-${indicatorArr[1]}`;
                  subQuestionTemplate.questionIndicator = bussiIndicator.indicator;
                  subQuestionTemplate.docUploadRespDateTime = bussiIndicator.docUploadRespDateTime;
                  subQuestionTemplate.iccmRespDateTime = bussiIndicator.iccmRespDateTime;
                  questionItem.subQuestions.push(subQuestionTemplate);
                }
                // 把答案放入当前界面结构中
                if(bussiIndicator != null && (indicator === subIndicator)) {
                  subQuestionsItem.userAnswer = bussiIndicator || {};
                }

              })
            }
            if(answerDetails && Object.keys(answerDetails).length > 0) {
              Object.keys(answerDetails).map((indicator, index) => {
                const answerIndi = answerDetails[indicator];
                if(answerIndi && indicator === subIndicator){
                  subQuestionsItem.userAnswer.chosenAnswerId = answerIndi;
                  if (subQuestionsItem.questionId === 'Q004-002-000') soleTraderAnswer = answerIndi;
                }
              })
            }
          });
          const questionItemTmp = JSON.parse(JSON.stringify(questionItem));
          // copy current page
          this.setState({
            pageData : { [this.pageKey]: questionItemTmp },
            copyPageData : { [this.pageKey]: questionItemTmp },
            currentPage: questionItemTmp,
            soleTraderAnswer
          });
        }
      });
      if (isMatchUrl) history.push(paths.dashboard.path);
    }
  }
  isOtherFileIndicateID = (indicate) => {
    const otherfileIndicate = ['MenuOtherDocFile', 'MenuOtherDocFileOff'];
    return otherfileIndicate.some(item => item === indicate);
  };

  closeModal() {
    this.setState({ isShowModal: false });
  };

  closeFileView() {
    this.setState({ isFileView: false });
  };

  openDeleteDialog(questionId) {
    const { currentPage } = this.state;
    // current id
    const currrentCopy = currentPage && JSON.parse(JSON.stringify(currentPage));
    if (this.isOtherFileIndicateID(currrentCopy.questionIndicator) && currrentCopy.subQuestions.length === 1) {
      this.setState({ isShowOtherDialog: true, deleteQuestionId: questionId });
    } else {
      this.setState({ isShowDialog: true, deleteQuestionId: questionId });
    }
  }

  closeDeleteDialog() {
    this.setState({ isShowDialog: false });
  };

  closeOtherDeleteDialog() {
    this.setState({ isShowOtherDialog: false });
  };

  findCurrentSectionByApplication = (application, id) => {
    const uploadFileSection = findQuestionById(application, "S004");
    const { questions } = uploadFileSection;

    const currentSection = questions.filter(question => question.questionId === id)
    if (currentSection && currentSection.length > 0) {
      return JSON.parse(JSON.stringify(currentSection[0]));
    }
    return null;
  };

  // 返回
  handlePrev() {
    const { applicationInfo } = this.props;
    const { currentPage, copyPageData } = this.state;
    const copyCurrentSection = copyPageData && copyPageData[this.pageKey];
    // Dialog is go back ？
    if (applicationInfo && currentPage) {
      if (JSON.stringify(copyCurrentSection) !== JSON.stringify(currentPage)) {
        const { form_base_content } = this.props;
        this.showDialog({
          showModal: true,
          popupType: 'back',
          content: form_base_content.back_prompt,
          backAction: this.closeDialog,
          confirmAction: this.backToFileUploadPage,
          closeAction: this.closeDialog
        });
      } else {
        this.backToFileUploadPage();
      }
    } else {
      this.backToFileUploadPage();
    }
    this.scrollToTop();
  };

  backToFileUploadPage = () => {
    const { allPageArr, indicatorArr } = this.pageStatus();
    let nextQuestionId;
    const nextPageIndex = allPageArr.indexOf(this.pageKey) - 1;
    if (nextPageIndex >= 0) {
      nextQuestionId = indicatorArr[nextPageIndex];
    } else {
      // last page id
      nextQuestionId = false;
    }

    // to next page
    if (nextQuestionId) {
      history.push(paths.file_upload_info.path(nextQuestionId));
    } else {
      history.push(paths.dashboard.path);
    }
    this.setState({ errorMsg: null })
    this.closeDialog();
  };

  // New upload
  handleUploadFile(event, questionId, questionIndicator) {
    const target = event.target;
    // questionId , colse error tips, open Loadeding
    this.errorLoaddingOpenClose(questionId, false, true);
    const filesTarget = target.files[0] || null;
    if (filesTarget) {
      // 判断格式是否正确
      const regs = /^gif|jpg|jpeg|png|pdf$/i;
      const fileFormat = target.files[0].name.substring(filesTarget.name.lastIndexOf(".") + 1, filesTarget.name.length);
      const isFileFormat = regs.test(fileFormat);
      if(!isFileFormat) {
        // 上传格式错误
        this.errorLoaddingOpenClose(questionId, 1, false);
        return;
      }

      if(filesTarget.size > (5*1024*1024)) {
        // 上传的文件大于5M
        this.errorLoaddingOpenClose(questionId, 3, false);
        return;
      }
      if(filesTarget.name.length > 100) {
        // 上传的文件名大于100字符
        this.errorLoaddingOpenClose(questionId, 5, false);
        return;
      }
      if (target.type === 'file') {
        const { requestJson } = this.state;
        // call the first API
        this.props.uploadFile(filesTarget, JSON.stringify(requestJson), questionId)
          .then(result => {
            if (result) {
              const { currentPage } = this.state
              currentPage.subQuestions.map(item => {
                if (item.questionId === questionId) {
                  item.userAnswer = {
                    "name": filesTarget.name || null,
                    "documentUploadId": result.documentUploadId || null,
                    "iccmFileNetId": null,
                    "fileNetId": null,
                    "status": result.status || null,
                    "type": null,
                    "indicator": item.questionIndicator || null,
                    "docUploadRespDateTime": result.responseDateTime,
                    "iccmRespDateTime": null
                  }
                }
              });
              this.setState({
                pageData: { [this.pageKey]: currentPage },
                currentPage });
              this.props.showFileloading({ [questionId]: true });
              // questionId , colse error tips, colse Loadeding
              this.errorLoaddingOpenClose(questionId, false, false);
            } else {
              // 上传异常
              this.errorLoaddingOpenClose(questionId, 2, false);
            }
          })
          .catch(error => {
            // 上传异常
            this.errorLoaddingOpenClose(questionId, 2, false);
          });
      }
    }
  }

  // questionId, error tips, Loadeding
  errorLoaddingOpenClose = (questionId, errorNum, isOpenLoading) => {
    // error
    this.setState({
      errorMsg: {
        ...this.state.errorMsg,
        [questionId]: errorNum
      }
    });

    // loading
    const datas = {
      [questionId]: {
        isUploadLoading: isOpenLoading
      }
    };
    this.props.fileUploadInfoLoading(datas);
  };

  // 文件预览
  handleFileView(questionId, fileViewtitle) {
    const { currentPage } = this.state;
    //track event
    trackEvent('file_upload_info');
    currentPage.subQuestions.map((subQuestion, index) => {
      if (subQuestion.questionId === questionId) {
        const userAnswer = subQuestion.userAnswer;
        const iccmFileNetId = userAnswer.iccmFileNetId;
        const name = userAnswer.name;

        // 获得格式
        const reg = /^pdf$/i;
        const fileFormat = name.substring(name.lastIndexOf(".") + 1, name.length);
        const isPDF = reg.test(fileFormat);
        // 如果是PDF格式, 下载方式:
        if(isPDF) {
          this.props.downloadFlie(iccmFileNetId)
            .then(result => {
              if(result.respCode === "200") {
                const downloadKey = result.respBody.key;
                const filePath = settings.hostnameDownloadFlie + apiMap.getDownloadFile(`1/${downloadKey}`).api;
                window.open(filePath);
              }
            })
            .catch(error => {
              this.setState({ isFileView: false });
            });
        } else {
          // image是格式, 查看方式:
          this.setState({
            isFileView: true
          });
          this.props.downloadFlie(iccmFileNetId)
            .then(result => {
              if(result.respCode === "200") {
                const downloadKey = result.respBody.key;
                this.props.downloadImageFlie(`0/${downloadKey}`)
                  .then(result => {
                    const contnt = result.respBody.contnt;
                    const fileBase64 = contnt !== undefined ? "data:image/"+ fileFormat +";base64," + contnt : "";
                    const datas = {
                      [questionId] : {
                        "src": fileBase64,
                        "isPDF": isPDF
                      }
                    };
                    this.props.fileUploadInfoView(datas, questionId);
                    this.props.showFileloading({
                      [questionId]: false
                    });
                  })
                  .catch(error => {
                    this.setState({ isFileView: false });
                  });
              }
            })
            .catch(error => {
              this.setState({ isFileView: false });
            });
        }
      }
    });
    this.questionId = questionId;
    this.fileViewtitle = fileViewtitle;

  };

  // 分离答案
  handleGetAnswer = (currentPage) => {
    const uploadFiles = {};
    const questionStatus = {};
    const answerDetails = {};
    const questionIndicatorMain = currentPage.questionIndicator;
    const statusTmp = [];
    // 界面(其他文件)
    if(currentPage && this.isOtherFileIndicateID(currentPage.questionIndicator)) {
      // 判断:(其他文件)结构（OtherDocFile） 是否被delete ?
      let otherId = 'OtherDocFile';
      if (questionIndicatorMain && questionIndicatorMain.indexOf('Off') > -1) {
        otherId = otherId + 'Off';
      }
      //还原(其他文件)第一个结构
      const subQ = currentPage && currentPage.subQuestions[0];
      subQ.questionIndicator = otherId;
      subQ.questionId = `${this.pageKey}-001`
      if(subQ.userAnswer){
        subQ.userAnswer.indicator = otherId;
      }
    }
    // 设置uploadFiles
    currentPage && currentPage.subQuestions.map((subQuestionsItem, index) => {
      const { answerType, userAnswer, questionIndicator, questionId } = subQuestionsItem;
      const isShow = this.SoleTraderUpload(questionId, questionIndicatorMain);
      if(answerType === 5 && userAnswer && userAnswer.chosenAnswerId) {
        answerDetails[questionIndicator] = userAnswer.chosenAnswerId;
      }
      if(answerType === 6) {
        if (userAnswer && userAnswer.status && isShow) {
          uploadFiles[questionIndicator] = userAnswer;
        } else {
          uploadFiles[questionIndicator] = null;
        }

        if(userAnswer && isShow) {
          const apiStatus = ['RECEIVED', 'PROCESSING', 'AV_PROCESSING', 'ANTIVIRUS_PASSED', 'CONVERTED', 'ICCM_PROCESSING', 'SAVE_REQUESTED'];
          if (userAnswer.status === 'SAVED') {
            statusTmp.push('2');
          } else if (apiStatus.indexOf(userAnswer.status) > -1) {
            statusTmp.push('1');
          } else if (userAnswer.status !== '' && userAnswer.status !== null) {
            statusTmp.push('3');
          } else {
            statusTmp.push('0');
          }
        }
      }
    });

    // 设置questionStatus
    if (statusTmp.length > 0) {
      if (statusTmp.indexOf('3') > -1) {
        questionStatus[questionIndicatorMain] = '3';
      } else if (statusTmp.indexOf('1') > -1) {
        questionStatus[questionIndicatorMain] = '1';
      } else if (statusTmp.indexOf('0') > -1 && statusTmp.indexOf('2') > -1) {
        questionStatus[questionIndicatorMain] = '4';
      } else if (statusTmp.indexOf('0') > -1) {
        questionStatus[questionIndicatorMain] = '0';
      } else {
        questionStatus[questionIndicatorMain] = '2';
      }
    } else {
      questionStatus[questionIndicatorMain] = '0';
    }

    // 点击上传文件下一步时添加下面字段，用于处理初始化时显示开始按钮
    questionStatus['uploadFileMandatory'] = 'N'

    // 清空uploadFiles里多余的答案(比如：新增文件结构被手动delete了)
    const uploadF = this.props.businessInfo.uploadFiles;
    Object.keys(uploadF).map((item, index) => {
      const questionIndicatorArr = item && item.split(currentPage.questionIndicator);
      if(questionIndicatorArr && questionIndicatorArr[1] && questionIndicatorArr[1].length > 0 && parseInt(questionIndicatorArr[1]) > 0) {
        if(Object.keys(uploadFiles).indexOf(item) === -1) {
          uploadFiles[item] = null;
        }
      }
    });

    // CALL API 的参数
    const businessInfoParams = {
      "uploadFiles": uploadFiles,
      "answerDetails": answerDetails,
      "questionStatus": questionStatus
    };
    return businessInfoParams;
  };

  // 获得（审核）结果 --> pageData
  getStatusFile = () => {
    const { currentPage } = this.state;
    return new Promise((resolve, reject) => {
      const { subQuestions, questionIndicator } = currentPage;
      const subItemType = subQuestions.filter(item => item.answerType === 6);
      // 获得需要查询status的documentUploadId集合
      let documentIdTmp = [];
      subItemType.map((item, index) => {
        const { questionId, userAnswer } = item;
        const isShow = this.SoleTraderUpload(questionId, questionIndicator);
        if(isShow && item.userAnswer && userAnswer.documentUploadId && userAnswer.status !== "SAVED") {
          documentIdTmp.push(userAnswer.documentUploadId);
        }

      });
      // documentUploadId集合 -> call API
      if(documentIdTmp.length > 0) {
        this.props.getStatusFile(documentIdTmp.join(','))
          .then(res => {
            if(res && res.length > 0){
              res.map(result => {
                subItemType.map((item, index) => {
                  const documentId = item.userAnswer && item.userAnswer.documentUploadId;
                  if (documentId === result.documentUploadId) {
                    item.userAnswer = {
                      "name": result.documentName || null,
                      "documentUploadId": result.documentUploadId  || null,
                      "iccmFileNetId": result.iccmFileNetId || null,
                      "fileNetId": result.fileNetId || null,
                      "status": result.status || null,
                      "type": result.mimeType || null,
                      "indicator": item.questionIndicator || item.questionId,
                      "docUploadRespDateTime": item.userAnswer.docUploadRespDateTime,
                      "iccmRespDateTime": result.iccmRespDateTime || null
                    }
                  }
                });
              });
              resolve && resolve(currentPage);
            } else {
              resolve && resolve(currentPage);
            }
          })
          .catch(error => {
            resolve && resolve(currentPage);
          })
      } else {
        resolve && resolve(currentPage);
      }
    })
  };

  // 完成
  handleFinish = (btnType) => {
    const { businessInfo } = this.props;
    const { currentPage } = this.state;
    // it is have error ?
    let isHaveError = false;
    const condition = JSON.parse(currentPage.condition);
    if (condition.mandatory && btnType !== 'save') {
      isHaveError = this.handIsHaveError();
    }
    if (!isHaveError) {
      this.getStatusFile()
        .then(currentPage => {
          // 过滤掉pageData：新增上传文件的结构, 但没上传文件, 在'储存'时，设置它userAnswer为null。
          const { questionIndicator, subQuestions } = currentPage;
          subQuestions.map((subQuestion,index) => {
            if(subQuestion.answerType === 6) {
              const isDataNull = subQuestion.questionIndicator.indexOf(questionIndicator) === 0 && subQuestion.userAnswer.status === null;
              if(isDataNull) {
                // 清空userAnswer
                subQuestion.userAnswer = null;
              }
            }
          });
          // 分离答案出来
          const businessInfoParams = this.handleGetAnswer(currentPage);
          const { uploadFiles, questionStatus, answerDetails } = businessInfoParams;
          // 临时store
          businessInfo.uploadFiles =  {
            ...businessInfo.uploadFiles,
            ...uploadFiles
          };
          businessInfo.questionStatus = {
            ...businessInfo.questionStatus,
            ...questionStatus
          };
          businessInfo.answerDetails = {
            ...businessInfo.answerDetails,
            ...answerDetails
          };
          // call API
          this.props.uploadFileFinish(businessInfoParams)
          .then(result => {
            this.triggerNextUrl(businessInfo.uploadFiles, btnType)
          })
          .catch(error => {
          });
          this.scrollToTop();
        })
        .catch(error => {
        })
    }

  };

  triggerNextUrl = (uploadFiles, btnType) => {
    if (btnType === 'save') {
      history.push(paths.dashboard.path);
    } else {
      // pageStatus
      const { allPageArr, indicatorArr } = this.pageStatus();
      const nextPageIndex = allPageArr.indexOf(this.pageKey); // 当前的index
      if (nextPageIndex < allPageArr.length - 1 && nextPageIndex > -1) {
        // 如果下个界面是"其他文件""
        const MainIndicator = indicatorArr[nextPageIndex + 1];
        const ind = MainIndicator.split("Menu")[1];
        if (this.isOtherFileIndicateID(MainIndicator) &&
          (!uploadFiles[ind] || (uploadFiles[ind] && uploadFiles[ind].status === null))) {
          // other file is null
          history.push(paths.dashboard.path);
        } else {
          // to next page
          history.push(paths.file_upload_info.path(MainIndicator));
        }
      } else {
        history.push(paths.dashboard.path);
      }
    }
  };
  // 判断是否有error
  handIsHaveError = () => {
    // validation
    this.validation();
    const { errorMsg, soleTraderAnswer, currentPage } = this.state;
    const { questionIndicator } = currentPage;
    let isHaveNullError = false;
    if (questionIndicator === this.soleTraderIndicator && soleTraderAnswer==='A004-002-000:001') {
      if (errorMsg['Q004-002-001'] && 'Q004-002-001'.indexOf(this.pageKey) > -1) {
        isHaveNullError = true;
      }
    } else {
      errorMsg && Object.keys(errorMsg).map((item,index) => {
        //判断是否为空
        if (item !== 'Q004-002-001' && errorMsg[item] && item.indexOf(this.pageKey) > -1) {
          isHaveNullError = true;
        }
      });
    }
    return isHaveNullError;

  };

  // 获得page status
  pageStatus = (currentPage) => {
    const { applicationInfo } = this.props;
    // const uploadFiles = businessInfo.uploadFiles;
    let allArr = [];
    let indArr = [];
    const sectionInfoS004 = findQuestionById(applicationInfo, 'S004');
    sectionInfoS004 && sectionInfoS004.questions.map((item, index) => {
      if (documentCheckListQuestionShouldDisplay(applicationInfo, item)) {
        const { questionIndicator, questionStatus } = item;
        if (this.isOtherFileIndicateID(questionIndicator) &&
          item.subQuestions.length === 1 && parseInt(questionStatus) === 0){
          // 其它文件-不显示
        } else {
          allArr.push(item.questionId);
          indArr.push(item.questionIndicator);
        }
      }
    });
    let currentStep = allArr && allArr.indexOf(this.pageKey) + 1;
    let totalStep = allArr && allArr.length;
    // 如果界面是"其它文件"
    if(currentPage && this.isOtherFileIndicateID(currentPage.questionIndicator)) {
      const { subQuestions, questionStatus } = currentPage;
      if (subQuestions.length === 1 && parseInt(questionStatus) === 0) {
        // 其它文件-userAnswer 为空
        currentStep = totalStep + 1;
        totalStep = totalStep + 1;
      } else {
        // 其它文件-userAnswer 有值
        currentStep = totalStep;
      }
    }

    return {
      allPageArr: allArr,
      indicatorArr: indArr,
      currentStep,
      totalStep
    };
  };

  // 其他文件--delete last file
  handleDeleteLastFileStorage() {
    const { businessInfo } = this.props;
    const { currentPage } = this.state;
    let otherId = 'OtherDocFile';
    if (currentPage && currentPage.questionIndicator.indexOf('Off') > -1) {
      otherId = otherId + 'Off';
    }
    currentPage.subQuestions.map((item, index) => {
      if(item.answerType === 6) {
        item.questionIndicator = otherId;
        item.questionStatus = '0';
        item.questionId = `${this.pageKey}-001`;
        item.userAnswer = null;
      }
    });

    // 分离答案出来
    const businessInfoParams = this.handleGetAnswer(currentPage);
    const { uploadFiles, questionStatus} = businessInfoParams;
    // call API
    this.props.uploadFileFinish(businessInfoParams)
      .then(result => {

        // 临时store status
        businessInfo.uploadFiles =  {
          ...businessInfo.uploadFiles,
          ...uploadFiles
        };
        businessInfo.questionStatus = {
          ...businessInfo.questionStatus,
          ...questionStatus
        };
        history.push(paths.dashboard.path);
      })
      .catch(error => {
      });

    this.closeOtherDeleteDialog();
  }

  validation() {
    const { currentPage, soleTraderAnswer } = this.state;
    const { i18n } = this.props;
    const { questionIndicator } = currentPage;
    // current id
    let errorArr = {};
    if (questionIndicator === this.soleTraderIndicator && soleTraderAnswer === '') {
      errorArr['Q004-002-000'] = i18n.placeHolder;
    } else {
      currentPage.subQuestions.map((subQuestion, index) => {
        const { answerType, userAnswer, questionId } = subQuestion;
        if (answerType === 6) {
          const isShow = this.SoleTraderUpload(questionId, questionIndicator);
          if (isShow && (userAnswer === null ||
            userAnswer === '' ||
            JSON.stringify(userAnswer) === '{}' ||
            (userAnswer && subQuestion.userAnswer.status === null)))
          {
            errorArr[subQuestion.questionId] = 4;
          }
        }
      })
    }
    this.setState({
      errorMsg: {
        ...this.state.errorMsg,
        ...errorArr
      }
    });
    this.state.errorMsg = {
      ...this.state.errorMsg,
      ...errorArr
    }
  }

  // add 文件
  addOtherFile() {
    const { flieUploadInfo } = this.props;
    const { currentPage } = this.state;
    const currentCopy = JSON.parse(JSON.stringify(currentPage));
    // subQuestionTemplate
    const subQuestionTemplate = JSON.parse(JSON.stringify(flieUploadInfo.subQuestionTemplate));
    // edit new subQuestionTemplate questionId
    let questionIdArray = [];
    if (currentCopy) {
      currentCopy.subQuestions.map((item, index) => {
        questionIdArray.push(item.questionId);
      });
    }
    let numArr = [];
    if(questionIdArray) {
      questionIdArray.map((item, index) => {
        numArr.push(parseInt(item.split(this.pageKey + "-")[1]));
      });
    }
    // 获得max id num
    const maxNums = Math.max.apply(null,numArr);

    let lastNum;
    if (0 < maxNums < 9) {
      lastNum = '00' + (maxNums + 1); // 001-009
    } else if (9 <= maxNums <= 98) {
      lastNum = '0' + (maxNums + 1); // 010-099
    } else if (99 <= maxNums) {
      lastNum = maxNums + 1; // 100-无极
    } else {
      lastNum = '001'; // 001
    }
    subQuestionTemplate.questionId = this.pageKey + '-' + lastNum;
    subQuestionTemplate.questionIndicator = `${currentCopy.questionIndicator}${lastNum}`;
    subQuestionTemplate.userAnswer.indicator = `${currentCopy.questionIndicator}${lastNum}`;
    // insert to subQuestions
    currentCopy.subQuestions.push(subQuestionTemplate);
    this.setState({
      pageData: { [this.pageKey]: currentCopy },
      currentPage: currentCopy
    });
  }

  // delete 文件
  deleteOtherFile(questionId) {
    const { currentPage } = this.state;
    // current id
    if (currentPage) {
      let questionIndex = -1;
      currentPage.subQuestions.map((item, index) => {
        if (item.questionId === questionId) {
          questionIndex = index;
        }
      }); 

      if (questionIndex !== -1) {
        let subQuestions = currentPage.subQuestions.filter(x=>x.index===currentPage.subQuestions[questionIndex].index);
        if (this.isOtherFileIndicateID(currentPage.questionIndicator)){//<其他>page
            if(currentPage.subQuestions.length === 1){
              this.handleDeleteLastFileStorage();
            } else {
              currentPage.subQuestions.splice(questionIndex, 1);
              this.closeDeleteDialog();
            }
        } else {//非<其他>page
            if(subQuestions[0].questionIndicator === currentPage.subQuestions[questionIndex].questionIndicator){
                Object.keys(currentPage.subQuestions[questionIndex].userAnswer).forEach(function (key) {
                  if (!(key === "indicator")){
                    currentPage.subQuestions[questionIndex].userAnswer[key] = null;
                  }
                });
            } else {
                currentPage.subQuestions.splice(questionIndex, 1);
            }
            this.closeDeleteDialog();
        } 
      }
    }

    // loading close
    let datas = {
      [questionId] : {
        isUploadLoading: false
      }
    };
    this.props.fileUploadInfoLoading(datas);

    // 清空：为error的提示。
    this.setState({
      errorMsg: {
        ...this.state.errorMsg,
        [questionId]: false
      },
      pageData: { [this.pageKey]: currentPage },
      currentPage
    });
  }

  showDialog = (dialogInfo) => {
    this.setState({
      dialogObj: dialogInfo
    });
  };

  closeDialog = () => {
    this.setState({
      dialogObj: null
    });
  };

  pdfLink = (answerLocales, questionIndicator) => {
    const { selectedLanguage } = this.props;

    if (questionIndicator === 'OrgChartFileTemplate' || questionIndicator === 'OwnStrucChartOffFileTemplate') {
      window.open(OrgChartOff,"_blank");
    } else if (questionIndicator === 'ComReportStandIndSelfCertFileTemplate') {
      window.open(ComReportStandIndSelfCertFile,"_blank");
    } else if (questionIndicator === 'DeclaStaAccUSTaxPrinFileTemplate') {
      window.open(DeclaStaAccUSTaxPrinFile,"_blank");
    } else {
      if(selectedLanguage === "zh-CN") {
        window.open(answerLocales[0].detail, "_blank");
      } else {
        window.open(answerLocales[1].detail, "_blank");
      }
    }
  };

  btnDisabled = () => {
    const { flieUploadInfo } = this.props;
    const uploadFileLoading = flieUploadInfo.uploadFileLoading;
    // save btn is disabled ?
    let isDisabled = false;
    uploadFileLoading && Object.keys(uploadFileLoading) && Object.keys(uploadFileLoading).map((item,index) => {
      if(item.split(this.pageKey).length === 2 ) {
        // is loading...
        if (uploadFileLoading[item].isUploadLoading) {
          isDisabled = true; // btn hide
        }
      }
    });
    return isDisabled;
  };

  getOptionalContent = (currentPage) => {
    const { i18n } = this.props;
    const { questionIndicator } = currentPage;
    const headAllInfo = i18n.fileUploadInfo.optionalContent;
    let tmp = i18n.fileUploadInfo.headTips;
    if(headAllInfo && headAllInfo[questionIndicator]) {
      tmp =  tmp + '<br />' + headAllInfo[questionIndicator];
    } else if (questionIndicator === 'PerIdenDoc') {
      tmp =  tmp + '<br />' + headAllInfo[questionIndicator + 'Off'];
    }
    return tmp;
  };
  valueDidChange = (obj, value) => {
    const { currentPage, errorMsg } = this.state;
    obj.userAnswer = { chosenAnswerId: value };
    errorMsg && errorMsg[obj.questionId] && delete errorMsg[obj.questionId];
    this.setState({
      currentPage,
      soleTraderAnswer: value
    })
  };
  SoleTraderUpload = (questionId, indicate) => {
    const { soleTraderAnswer } = this.state;
    let isShow = true;
    const threeInthree = ['Q004-002-002', 'Q004-002-003', 'Q004-002-004'];
    if (indicate === this.soleTraderIndicator) {
      if (soleTraderAnswer === 'A004-002-000:001' &&  questionId === 'Q004-002-001') {
        isShow = true;
      } else if (soleTraderAnswer === 'A004-002-000:002' && threeInthree.indexOf(questionId) > -1) {
        isShow = true;
      } else {
        isShow = false;
      }
    }
    return isShow;
  };
  handleSubQuestions = (subQuestions, type, indicate) => {
    if (!subQuestions) {
      return null;
    }
    const { selectedLanguage, i18n, flieUploadInfo } = this.props;
    const { errorMsg } = this.state;
    return subQuestions.map((item, index) => {
      const { answerType,
        questionIndicator,
        questionId,
        questionLocales,
        userAnswer,
        answers
      } = item;
      const isError = errorMsg && errorMsg[questionId] || false;
      let component = null;
      if (answerType === type) {
        const questionTitle = getContentByLocal(questionLocales, selectedLanguage);
        switch (answerType) {
          case 5: {
            let defaultValue = '';
            let answerOptions = answers && answers.map(ans => {
              return {
                id: ans.answerId,
                text: getContentByLocal(ans.answerLocales, selectedLanguage),
                dataKey: ans.answerIndicator
              }
            });
            if (answerOptions) {
              answerOptions = [{ id: "", 'text': i18n.placeHolder }, ...answerOptions];
            }
            if (userAnswer) {
              defaultValue = userAnswer.chosenAnswerId;
            }
            let selectContent = {
              itemTitle: {
                text: questionTitle,
                dataKey: `${questionIndicator}-subtitle`
              },
              validatedTips: errorMsg && errorMsg[questionId],
              selectOptions: answerOptions,
              placeHolder: 'please select',
              defaultValue: defaultValue,
              questionRel: item,
              dataKey: questionIndicator,
              isError: isError
            };
            this.getsoleAnser = defaultValue;
            component = <AOForm.Select
              key={questionIndicator}
              content={selectContent}
              onChangeAction={(obj, newValue) => { this.valueDidChange(obj, newValue) }}
            />;
            break;
          }
          case 28: {
            component = (
              <FileDesc
                content = {{
                  title: i18n.fileUploadInfo.pdftips,
                  file: getContentByLocal(questionLocales, selectedLanguage),
                  fileTip: i18n.fileUploadInfo.file || 'FILE',
                }}
                key={questionIndicator}
                onhandleChange= {() => this.pdfLink(item.answers[0].answerLocales, questionIndicator)}
              />
            );
            break;
          }
          case 6: {
            const isShowSoleTrader = this.SoleTraderUpload(questionId, indicate);
            const uChlid = flieUploadInfo.uploadFileLoading && flieUploadInfo.uploadFileLoading[item.questionId];
            const isUploadLoading = uChlid && uChlid.isUploadLoading;
            const apiStatusIng = ['RECEIVED', 'PROCESSING', 'AV_PROCESSING', 'ANTIVIRUS_PASSED', 'CONVERTED', 'ICCM_PROCESSING', 'SAVE_REQUESTED'];
            const apiStatusError = ['VALIDATION_FAILED', 'ANTIVIRUS_FAILED', 'ANTIVIRUS_CONNECTION_FAILED', 'CONVERSION_FAILED', 'ICCM_CONNECTION_FAILED', 'ICCM_PROCESSING_ERROR', 'ERROR', 'FORMAT_NOT_SUPPORTED'];
            let isStatus = 0; 
            if (item.userAnswer && item.userAnswer.iccmFileNetId && item.userAnswer.status === 'SAVED') {
              // 审核通过
              isStatus = 2;
            
            } else if (item.userAnswer && apiStatusIng.indexOf(item.userAnswer.status) > -1) {
              // 正在审核中...
              isStatus = 1;
            } else if (item.userAnswer && apiStatusError.indexOf(item.userAnswer.status) > -1) {
              // 审核不通过
              isStatus = 3;
            }
            let uploadObj = {
              controlLabel: questionTitle,
              errorMsg: errorMsg && errorMsg[questionId],
              isUploadLoading,
              i18n,
              questionIndicator,
              isStatus,
              key: index

            };
            let changePopupObj = getContentByLocal(item.questionLocales, selectedLanguage); 
            if(this.isOtherFileIndicateID(indicate)) {
              // 增加其他文件
              uploadObj = {
                ...uploadObj,
                controlLabel: index === 0 ? i18n.fileUploadInfo.otherFile : i18n.fileUploadInfo.otherFile + " " + (index + 1),
                isHaveLine: true,
                isHaveDelteBtn: true,
              };
              
              if (index !== 0) changePopupObj = i18n.fileUploadInfo.otherFile + " " + (index + 1);
            }else {
              if(index === 0){
                uploadObj = {
                  ...uploadObj,
                  controlLabel: questionTitle,
                  isHaveDelteBtn: subQuestions[index].userAnswer && subQuestions[index].userAnswer.name
                } 
              }
              else {
                uploadObj = {
                  ...uploadObj,
                  controlLabel: '',
                  isHaveDelteBtn: true
                }
             }
          }
            component = isShowSoleTrader ? <UploadCom
              {...uploadObj}
              inputFileValue={""}
              changePopup={() => this.handleFileView(questionId, changePopupObj)}
              onChangeAction={(event) => this.handleUploadFile(event, questionId, questionIndicator)}
              openDeleteDialog={() => this.openDeleteDialog(questionId)}
            /> : null;
            break;
          }
          default:
            break;
        }
      }
      return component;
    })
  };
  handleJsonToView = (json) => {
    const { subQuestions, questionIndicator } = json;
    const { i18n } = this.props;
    const fileDesc = this.handleSubQuestions(subQuestions, 28);
    const uploadList = this.handleSubQuestions(subQuestions, 6, questionIndicator);
    const formTitle = <AOForm.ContentOnly
      content={{
        title: i18n.fileUploadInfo.titleUploadDocument,
        dataKey: 'titleUploadDocument'
      }}
      key='formTitle'
    />;
    const dropDownList = this.handleSubQuestions(subQuestions, 5);
    const uploadAll = (<div className="file-upload-select" key="fileUpload">
      <div className="upload-input clearfix">
        {questionIndicator === this.soleTraderIndicator && dropDownList}
        {uploadList}
        {
          subQuestions[0] && subQuestions[0].canRepeat &&
          <Button title={i18n.fileUpload.addOtherFileTxt} className="add-other-fileupload" onClick={() => this.addOtherFile(this.pageKey)}>
            <i aria-hidden={true} className="icon icon-add"></i>
            <span>{i18n.fileUpload.addOtherFileTxt}</span>
          </Button>
        }
      </div>
    </div>);
    return [
      ...fileDesc,
      formTitle,
      uploadAll
    ]
  };

  render() {
    const { appMessages, selectedLanguage, i18n, flieUploadInfo, form_base_content, isShowFileloading, pageTitle } = this.props;
    const { currentPage, dialogObj, isShowModal, isFileView, imgModalArray, isShowDialog, isShowOtherDialog, deleteQuestionId } = this.state;
    const { currentStep, totalStep } = this.pageStatus(currentPage);

    if (currentPage && i18n && pageTitle) {
      const formTitleText = getContentByLocal(currentPage.questionLocales, selectedLanguage);
      setTitle( i18n.title + ' (' + formTitleText + ')' + pageTitle);
    }
    
    return (currentPage ?
        <div>
          <StepIndicator currentStep={currentStep} totalStep={totalStep} stepInfo={appMessages.stepInfo} stepTitle={i18n.fileUploadInfo.stepTitle} />
          <FormTitle content={{
            title: {
              text: getContentByLocal(currentPage.questionLocales, selectedLanguage),
              dataKey: 'file-upload-title'
            },
            subTitle: {
              text: this.getOptionalContent(currentPage),
              dataKey: 'file-upload-sub-title'
            }
          }} />
          <div className="file-upload-info" data-id={'FileUploadInfo-FileUploadInfo-page'}>
            <div className="form-item">
              <AOForm.ContentOnly
                content={{
                  title: i18n.fileUploadInfo.titleBeforeUpload,
                  dataKey: 'i18n.fileUploadInfo.titleBeforeUpload'
                }}
              />
            </div>

            <div className="tips-txt">
              <h5 data-key="arraytips">{i18n.fileUploadInfo.arraytips[0]}</h5>
              {
                i18n.fileUploadInfo.arraytips.map((item, index) => {
                  if (index !== 0) {
                    return <p key={index}  data-key={`arraytips-tip-${index}`}>{item}</p>
                  }
                })
              }
            </div>
            { this.handleJsonToView(currentPage) }
            <AOForm.BottomButtonsGroup
              backButtonDisabled={this.btnDisabled()}
              saveButtonDisabled={this.btnDisabled()}
              disabled={this.btnDisabled()}
              content={form_base_content.bottomButtonsContent}
              backAction={this.handlePrev}
              saveAction={() => {this.handleFinish('save')}}
              completeFormAction={this.handleFinish}
            />

            <FileSamplesView
              isShowModal={isShowModal}
              closeModal={this.closeModal}
              imgModalTitle={i18n.fileUploadInfo.fileSamplesTitle}
              imgModalArray={imgModalArray}
              flieUploadInfo={flieUploadInfo}
            />

            <FileView
              isFileView={isFileView}
              isShowFileloading={isShowFileloading}
              closeModal={this.closeFileView}
              i18n={i18n}
              questionId={this.questionId}
              fileViewtitle={this.fileViewtitle}
              flieUploadInfo={flieUploadInfo}
            />

            <AOForm.PopupModel
              showModal={isShowDialog}
              content={{
                title: {
                  text: i18n.fileUploadInfo.sureToDelete,
                  dataKey: 'i18n.fileUploadInfo.sureToDelete'
                },
                info: {
                  text: i18n.fileUploadInfo.sureToDeleteFile,
                  dataKey: 'i18n.fileUploadInfo.sureToDeleteFile'
                },
                backBtn: {
                  text: i18n.fileUploadInfo.gobackBtn,
                  dataKey: 'i18n.fileUploadInfo.gobackBtn'
                },
                confirmBtn: {
                  text: i18n.fileUploadInfo.sureBtn,
                  dataKey: 'i18n.fileUploadInfo.sureBtn'
                }

              }}
              confirmAction={() => this.deleteOtherFile(deleteQuestionId)}
              backAction={this.closeDeleteDialog}
              closeAction={this.closeDeleteDialog}
            />

            <AOForm.PopupModel
              showModal={isShowOtherDialog}
              content={{
                title: {
                  text: i18n.fileUploadInfo.sureToDelete,
                  dataKey: 'i18n.fileUploadInfo.sureToDelete'
                },
                info: {
                  text: i18n.fileUploadInfo.deleteOtherFileLast,
                  dataKey: 'i18n.fileUploadInfo.deleteOtherFileLast'
                },
                backBtn: {
                  text: i18n.fileUploadInfo.gobackBtn,
                  dataKey: 'i18n.fileUploadInfo.gobackBtn'
                },
                confirmBtn: {
                  text: i18n.fileUploadInfo.sureBtn,
                  dataKey: 'i18n.fileUploadInfo.sureBtn'
                }

              }}
              confirmAction={() => this.deleteOtherFile(deleteQuestionId)}
              backAction={this.closeOtherDeleteDialog}
              closeAction={this.closeOtherDeleteDialog}
            />

            {
              dialogObj ?
                <AOForm.PopupModel
                  {...dialogObj}
                /> : null
            }
          </div>
        </div>
        : null
    )
  }
}

export default FileUploadInfo;



// WEBPACK FOOTER //
// ./src/views/FileUploadInfo/components/FileUploadInfo.js